const DATE_RE = /^\d{4}-\d{2}-\d{2}$/
const MONTH_RE = /^\d{4}-\d{2}$/

const pad = value => String(value).padStart(2, '0')

const isValidDateInput = value => {
	if (!DATE_RE.test(String(value || ''))) return false
	const [year, month, day] = value.split('-').map(Number)
	const date = new Date(year, month - 1, day)
	return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day
}

const isValidMonthInput = value => {
	if (!MONTH_RE.test(String(value || ''))) return false
	const [year, month] = value.split('-').map(Number)
	return year >= 1000 && month >= 1 && month <= 12
}

const getStartOfDayIso = date => `${date}T00:00:00`

const getEndOfDayIso = date => `${date}T23:59:59`

const getMonthDateRange = month => {
	if (!isValidMonthInput(month)) return null
	const [year, monthNumber] = month.split('-').map(Number)
	const first = new Date(year, monthNumber - 1, 1)
	const last = new Date(year, monthNumber, 0)

	return {
		dateFrom: `${first.getFullYear()}-${pad(first.getMonth() + 1)}-${pad(first.getDate())}`,
		dateTo: `${last.getFullYear()}-${pad(last.getMonth() + 1)}-${pad(last.getDate())}`
	}
}

const compareDateInputs = (dateFrom, dateTo) => {
	if (!isValidDateInput(dateFrom) || !isValidDateInput(dateTo)) return null
	return dateFrom.localeCompare(dateTo)
}

export {
	isValidDateInput,
	isValidMonthInput,
	getStartOfDayIso,
	getEndOfDayIso,
	getMonthDateRange,
	compareDateInputs
}
